import { Injectable } from '@angular/core';
import { constants } from 'app/constants';
import { Location } from '@angular/common'
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  selectedNavItem: any = {};

  constructor(
    private location: Location,
    private router: Router
  ) { }

  
  /**
   * Set the SELECTED value as true for the selected nav item and its parent
   * @param index - index1, index2, index3 from parent to child
   */
   selectNavItem(navItems: any, indexList: any) {
    this.selectUnselectAll(navItems, false);
    const index1 = indexList[0];
    const index2 = indexList[1];
    const index3 = indexList[2];
    if (index1 != undefined) {
      navItems[index1]["selected"] = true;
    }
    if (index2 != undefined) {
      navItems[index1]['subItems'][index2]["selected"] = true;
    }
    if (index3 != undefined) {
      navItems[index1]['subItems'][index2]['subItems'][index3]["selected"] = true;
    }
  }

  /**
   * Sets the selected state of the sidebar nav item depending on the url
   */
  setSelectedNavItemByURL(navItems: any, url: string, isClick: boolean = true) {
    let indexList: any = [];
    const path = url.split("/");
    indexList = this.getNavItemsIndexList(navItems, path, 2, indexList);
    this.updateNavItemsState(navItems, indexList, isClick);
  }

  /**
   * Get the index tree for the given path
   */
  getNavItemsIndexList(navItems: any, path: any, pathIndex: number, indexList: any) {
    const pathName = path[pathIndex];
    if (!pathName) {
      return indexList;
    }
    for (let i = 0; i < navItems.length; i++) {
      // Remove all the white space
      const name = navItems[i]["name"].split(/\s/).join('');

      if (name.toLowerCase() === pathName.toLowerCase()) {
        indexList.push(i);
        pathIndex = pathIndex + 1;
        this.getNavItemsIndexList(navItems[i]['subItems'], path, pathIndex, indexList)
        break;
      }
    }

    return indexList;
  }

  /**
   * Set selected value as true or false, this is for the CSS
   * @param navItemList - sidebar navigation list
   * @param state - true for selected state, false for unselected state
   */
  selectUnselectAll(navItemList: any, state: boolean) {
    for (let i = 0; i < navItemList.length; i++) {
      navItemList[i]["selected"] = state;
      this.selectUnselectAll(navItemList[i]['subItems'], state);
    }
  }

  /**
   * Set SHOW value as true or false, this is for the CSS
   * @param navItemList - sidebar navigation list
   * @param state - true for show the child items, false for hide the child item
   */
  collapseAll(navItemList: any) {
    for (let i = 0; i < navItemList.length; i++) {
      if (navItemList[i]["path"]) {
        continue;
      }

      navItemList[i]["show"] = false;

      this.collapseAll(navItemList[i]['subItems']);
    }
  }

  /**
   * Manipulate the side navbar items - show/hide, select/unselect
   * @param isClick: If it is a click event, then no need to update all parent values.
   * Like Product tab is clicked, no need to update inventory. As it is already true.
   * This would create a problem as it would change Inventory to false.
   * This will close all the child instead of opening up the product.
   * So all the parents and child are updated only if it is from url.
   */
  updateNavItemsState(navItemsList: any, indexList: any, isClick: boolean = true) {
    const index1 = indexList[0];
    const index2 = indexList[1];
    const index3 = indexList[2];
    let sideNavItemStateUpdated = false;
    if (index3 != undefined) {
      if (navItemsList[index1]['subItems'][index2]['subItems'][index3]["path"]) {
        // Update the selected nav item
        this.selectNavItem(navItemsList, indexList);
        this.selectedNavItem['name'] = navItemsList[index1]['subItems'][index2]['subItems'][index3]["id"];

        // Change the url

        //used before lazy loading
        // this.location.replaceState(navItemsList[index1]['subItems'][index2]['subItems'][index3]["path"]);

        //after lazy loading
        this.router.navigate([navItemsList[index1]['subItems'][index2]['subItems'][index3]["path"]]);
        if (isClick) {
          return;
        }
      } else {
        navItemsList[index1]['subItems'][index2]['subItems'][index3]['show'] = !navItemsList[index1]['subItems'][index2]['subItems'][index3]['show'];
      }
      if (isClick) {
        sideNavItemStateUpdated = true;
      }
    }

    if (index2 != undefined && !sideNavItemStateUpdated) {
      if (navItemsList[index1]['subItems'][index2]["path"]) {
        // Update the selected nav item
        this.selectNavItem(navItemsList, indexList);
        this.selectedNavItem['name'] = navItemsList[index1]['subItems'][index2]["id"];

        // Change the url
        // this.location.replaceState(navItemsList[index1]['subItems'][index2]["path"]);
        this.router.navigate([navItemsList[index1]['subItems'][index2]["path"]]);
        if (isClick) {
          return;
        }
      } else {
        navItemsList[index1]['subItems'][index2]['show'] = !navItemsList[index1]['subItems'][index2]['show'];
      }
      if (isClick) {
        sideNavItemStateUpdated = true;
      }
    }

    if (index1 != undefined && !sideNavItemStateUpdated) {
      if (navItemsList[index1]["path"]) {
        // Update the selected nav item
        this.selectNavItem(navItemsList,indexList);
        this.selectedNavItem['name'] = navItemsList[index1]["id"];

        // Change the url
        // this.location.replaceState(navItemsList[index1]["path"]);
        this.router.navigate([navItemsList[index1]["path"]]);
        if (isClick) {
          return;
        }
      } else {
        // To close all childs elements too
        if (navItemsList[index1]['show']) {
          this.collapseAll(navItemsList[index1]['subItems'])
        }
        navItemsList[index1]['show'] = !navItemsList[index1]['show'];
      }
    }
  }
}
